<template>

  <div>
    <div v-for="field in fields"
         :key="field.model">
      <p class="p-form-label">{{ field.label }}
        <span v-if="!field.isRequired"
              class="grey--text font-italic"> - Optional
        </span>
        <span v-if="isEmpty(field.restriction)"
              class="d-block grey--text ma-0 mb-1">{{ field.restriction }}
        </span>
      </p>
      <b-form-textarea v-if="field.isRequired"
                       v-model="data[field.model]"
                       :class="{ 'custom-invalid-input-border': $data.$v[field.model].$error }"
                       :disabled="!editable"
                       :placeholder="placeholder"
                       :rows="3"
                       @input="$data.$v[field.model].$touch()">
      </b-form-textarea>
      <b-form-textarea v-else
                       v-model="data[field.model]"
                       :disabled="!editable"
                       :placeholder="placeholder"
                       :rows="3">
      </b-form-textarea>
    </div>
  </div>

</template>

<script>

  export default {
    name: 'ExtendedTextArea',
    props: {
      value: undefined,
      validation: undefined,
      editable: {
        type: Boolean,
        default: true,
      },
      fields: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        data: this.value,
        $v: this.validation,
        placeholder: 'Enter missing value',
      };
    },
    methods: {
      isEmpty(restriction) {
        return restriction !== '';
      },
    },
    watch: {
      value: {
        handler() {
          this.data = this.value;
          if (this.data === undefined) this.data = {};
        },
        deep: true,
      },
    },
  };
</script>
